// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import KnowledgeGraph from '../site-sections/KnowledgeGraph';

/**
 * Site → Knowledge Graph. Reuses the existing digital-twin-backed graph
 * (KnowledgeGraph reads :site_id from the route). Wrapped in the Carbon shell
 * page; the graph internals keep their real data wiring (useDigitalTwin).
 */
export default function SiteKnowledgeGraph() {
  return (
    <div className="hs-page" style={{ maxWidth: 'none', height: '100%' }}>
      <KnowledgeGraph />
    </div>
  );
}
